import styled from "styled-components";

const Row = styled.div.attrs({ className: "row" })``;
const Column = styled.div.attrs({ className: "col-md-4" })``;
const FullColumn = styled.div.attrs({ className: "col-md-12" })``;
const HalfColumn = styled.div.attrs({ className: "col-md-6" })``;

export { Row, Column, FullColumn, HalfColumn };
